import React, { Fragment } from 'react';
import { Card } from 'reactstrap';

const ProductVariantsCard = ({ className, variants }) => {
  return (
    <Fragment>
      <h3 className="f3 mt0">Variants</h3>
      <Card className={className}>
        <table className="table mb0">
          <thead>
            <tr>
              <th className="bt-n bb-n table-header" />
              <th className="bt-n bb-n table-header">Name</th>
              <th className="bt-n bb-n table-header">Tax (per litre)</th>
              <th className="bt-n bb-n table-header">Packaging</th>
              <th className="bt-n bb-n table-header" />
            </tr>
          </thead>
          <tbody>
            {variants.map(({ id, name, vesselType, packagingCost, taxPerLitre }) => (
              <tr className="table-row" key={id}>
                <td />
                <td>
                  <strong>{name}</strong>
                </td>
                <td>
                  <em>${taxPerLitre}</em>
                </td>
                <td>
                  <em>${packagingCost}</em>
                </td>
                <td>
                  {vesselType.volume}L {vesselType.quantity > 1 ? ` x ${vesselType.quantity}` : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </Fragment>
  );
};

export default ProductVariantsCard;



// WEBPACK FOOTER //
// ./src/components/productVariantsCard/productVariantsCard.jsx